export class InventoryImageDTO{
    public id?:number;
    public reference!:string;
    public sequenceNo?: number;
    public base64File!:string;
    public contentType?:string;

    constructor(){}
}